var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownloadIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 22,
    viewBox: "0 0 18 22",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.4375 17.5625C8.57812 17.7031 8.76562 17.75 9 17.75C9.1875 17.75 9.375 17.7031 9.51562 17.5625L16.2656 10.8125C16.5469 10.5312 16.5469 10.0156 16.2656 9.73438C15.9844 9.45312 15.4688 9.45312 15.1875 9.73438L9.75 15.2188V1.25C9.75 0.875 9.375 0.5 9 0.5C8.57812 0.5 8.25 0.875 8.25 1.25V15.2188L2.76562 9.73438C2.48438 9.45312 1.96875 9.45312 1.6875 9.73438C1.40625 10.0156 1.40625 10.5312 1.6875 10.8125L8.4375 17.5625ZM17.25 20H0.75C0.328125 20 0 20.375 0 20.75C0 21.1719 0.328125 21.5 0.75 21.5H17.25C17.625 21.5 18 21.1719 18 20.75C18 20.375 17.625 20 17.25 20Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadIcon);
export default __webpack_public_path__ + "static/media/download-icon.512e794493660196d1c9b9b12c386b8c.svg";
export { ForwardRef as ReactComponent };